import React, {Component} from "react"
import qs from "qs"

import session from "@irati/auth/services/session"
import loginService from "@irati/auth/services/login"
import {get} from "lodash"
import History from "@irati/utils/history"
import Loading from "@irati/ui/src/Loading"
import authentication from "@irati/auth"
import {REDIRECT_STORAGE_KEY} from "../../../constants/login"
import {HOME, ONBOARDING, PUBLIC, WELCOME} from "@irati-web/app/src/routeConfig"

interface Props {}

interface State {
  load: Promise<void> | null
}

class LoginCode extends Component<Props, State> {
  state: State = {
    load: null
  }

  componentDidMount() {
    const load = this.getLoginDetails()
    this.setState({load})
  }

  redirectBackTo = () => {
    const nextPathname = sessionStorage.getItem(REDIRECT_STORAGE_KEY) || get(this.props, "location.state.nextPathname", "")
    const isLogin = nextPathname.includes(WELCOME)
    if (!nextPathname || isLogin) {
      return null
    }
    if (nextPathname.includes(PUBLIC) || nextPathname.includes(ONBOARDING)) {
      return null
    }
    if (authentication.apps().admin && nextPathname.includes(HOME)) {
      return null
    }

    return nextPathname
  }

  getLoginDetails = () => {
    return session.getThenRemove(["accessToken", "state"]).then(({accessToken, state}) => {
      if (!accessToken) {
        History.push({pathname: "/welcome/login", state: {noAccessTokenError: true}})
      }
      const nextPathname = qs.parse(state).nextPathname as string
      const redirectionUrl = this.redirectBackTo() || nextPathname || "/"

      return loginService.ssoLogin(accessToken).then(() => {
        History.replace(redirectionUrl)
      })
    })
  }

  render() {
    return <Loading load={this.state.load} />
  }
}

export default LoginCode
